__turbopack_context__.v({
  "commandCode": "Command-module__yR19Fa__commandCode",
  "commandCopyButton": "Command-module__yR19Fa__commandCopyButton",
  "commandHeader": "Command-module__yR19Fa__commandHeader",
  "commandOsBadge": "Command-module__yR19Fa__commandOsBadge",
  "commandOutput": "Command-module__yR19Fa__commandOutput",
  "commandOutputCode": "Command-module__yR19Fa__commandOutputCode",
  "commandWrapper": "Command-module__yR19Fa__commandWrapper",
});
